<section class="invoice-list-page">
  <mat-card class="invoice-list-card">
    <mat-card-content>
      <header class="page-header">
        <button
          mat-icon-button
          type="button"
          class="back-button"
          routerLink="/principal/dashboard"
          aria-label="Voltar para o dashboard"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="page-title-group">
          <h1>Cobranças</h1>
          <p>Acompanhe suas cobranças e pagamentos.</p>
        </div>
      </header>

      @if (invoiceRows.length) {
        <section class="desktop-table" aria-label="Tabela de cobranças">
          <div class="table-shell">
            <table mat-table [dataSource]="dataSourceInvoices" class="invoice-table">
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">
                  <div class="">
                    <span [ngClass]="'badge ' + statusClass(row)">{{ statusLabel(row) }}</span>
<!--                    @if (row.DATA_PAGAMENTO) {-->
<!--                      <span class="status-note">{{ paymentNote(row) }}</span>-->
<!--                    } @else if (dueHint(row)) {-->
<!--                      <span class="status-note" [ngClass]="dueHintClass(row)">{{ dueHint(row) }}</span>-->
<!--                    }-->
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="referencia">
                <th mat-header-cell *matHeaderCellDef>Referência</th>
                <td mat-cell *matCellDef="let row">
                  <div class="reference-cell">
                    <strong>{{ row.CODIGO_FATURA }}</strong>
                    <span>{{ invoiceReference(row) }}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef>Descrição</th>
                <td mat-cell *matCellDef="let row">
                  <div class="description-cell">{{ row.DESCRICAO_FATURA }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="vencimento">
                <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                <td mat-cell *matCellDef="let row">
                  <div class="due-cell">
                    <strong>{{ formatDate(row.DATA_VENCIMENTO) }}</strong>
                    <span [ngClass]="dueHintClass(row)">{{ dueHint(row) }}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef class="amount-header">Valor</th>
                <td mat-cell *matCellDef="let row" class="amount-cell">
                  {{ formatCurrency(row.VALOR_TOTAL) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef class="actions-header">Ações</th>
                <td mat-cell *matCellDef="let row" class="actions-cell">
                  <button mat-stroked-button type="button" (click)="openInvoice(row.CODIGO_FATURA)">
                    <mat-icon>visibility</mat-icon>
                    Ver detalhes
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.next-invoice-row]="isNextPendingInvoice(row)"
              ></tr>
            </table>
          </div>
        </section>

        <section class="mobile-list" aria-label="Lista de cobranças em cards">
          @for (row of invoiceRows; track row.CODIGO_FATURA) {
            <mat-card class="invoice-mobile-card" [class.next-invoice-card]="isNextPendingInvoice(row)">
              <mat-card-content>
                <div class="mobile-card-top">
                  <mat-chip [ngClass]="statusClass(row)">
                    {{ statusLabel(row) }}
                  </mat-chip>

                  <div class="mobile-reference">
                    <strong>{{ row.CODIGO_FATURA }}</strong>
                    <span>{{ invoiceReference(row) }}</span>
                  </div>
                </div>

                <div class="mobile-description">{{ row.DESCRICAO_FATURA }}</div>

                <div class="mobile-meta">
                  <div>
                    <span class="meta-label">Vencimento</span>
                    <strong>{{ formatDate(row.DATA_VENCIMENTO) }}</strong>
                    <small [ngClass]="dueHintClass(row)">{{ row.DATA_PAGAMENTO ? paymentNote(row) : dueHint(row) }}</small>
                  </div>

                  <div class="mobile-amount">
                    <span class="meta-label">Valor</span>
                    <strong>{{ formatCurrency(row.VALOR_TOTAL) }}</strong>
                  </div>
                </div>

                <button mat-stroked-button type="button" class="mobile-action" (click)="openInvoice(row.CODIGO_FATURA)">
                  <mat-icon>visibility</mat-icon>
                  Ver detalhes
                </button>
              </mat-card-content>
            </mat-card>
          }
        </section>
      } @else {
        <div class="empty-state">
          <mat-icon>receipt_long</mat-icon>
          <h2>Você não possui cobranças cadastradas.</h2>
        </div>
      }
    </mat-card-content>
  </mat-card>
</section>
